// Core
import React from 'react';
import PropTypes from 'prop-types';

// A text link that runs code instead of going somewhere ("Cancel", "Forgot password?", "Load more").
// It renders the same <a> as before, so styling is unchanged, but it can be reached with Tab and
// triggered with Enter or Space, which a bare <a onClick> cannot.
const ActionLink = ({ onClick, onKeyDown, children, ...rest }) => {
  if (!onClick) {
    // nothing to trigger (the surrounding card handles the click): plain text that looks like a link
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return <a {...rest} onKeyDown={onKeyDown}>{children}</a>;
  }
  const handleKeyDown = (e) => {
    onKeyDown && onKeyDown(e);
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a role='button' tabIndex={0} {...rest} onClick={onClick} onKeyDown={handleKeyDown}>
      {children}
    </a>
  );
};

export default ActionLink;

ActionLink.propTypes = {
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  children: PropTypes.node
};
